import { useTranslation } from 'react-i18next';

import { AsyncSelect, GroupBase, useMultiSelect } from '@any-ui-react/select';
import { t } from 'i18next';

import { ValueEditorProps, useValueEditor } from '../../condition-builder';
import { Option } from '../../condition-builder/types';

const getValues = (values?: string[]): Option[] => {
  if (!values || values.length === 0) return [];

  return values.reduce((acc, value) => {
    if (!value) {
      return acc;
    }

    return [
      ...acc,
      {
        label: t('anychat.broadcast.conditions.influencer.categories.options', {
          category: value,
          ns: 'anychat',
        }),
        value,
      },
    ];
  }, [] as Option[]);
};

export const CategoryValueEditor = (props: ValueEditorProps) => {
  const { t } = useTranslation('anychat');
  const { baseProps, getErrorMessage } = useValueEditor(props);

  const error = getErrorMessage();
  const multiValueSelect = useMultiSelect({
    options: props.field?.values ?? [],
  });

  return (
    <AsyncSelect<Option, true, GroupBase<Option>>
      {...baseProps}
      {...multiValueSelect}
      {...props.field.componentProps}
      menuPortalTarget={document.body}
      classNames={{
        menu: () => 'min-w-76',
        valueContainer: () => 'flex-nowrap! [&_.option-label]:truncate',
        option: () => '[&_label]:truncate',
      }}
      placeholder={t('anychat.broadcast.conditions.influencer.categories.placeholder')}
      isClearable
      value={getValues(props.values)}
      defaultOptions
      onChange={(options) => props.onChange?.(options.map((option) => option.value))}
      error={error}
      wrapper={{ className: baseProps.className }}
      disabled={props.disabled}
    />
  );
};
